import createCache from '@emotion/cache';

const nonce = document
  ?.querySelector('meta[property="csp-nonce"]')
  ?.getAttribute('content') || undefined;

const cache = createCache({
  key: 'mui',
  nonce,
  prepend: true,
});

export default cache;
